import Vue from "vue";
import VueRouter from "vue-router";
// @ts-ignore
import { AmplifyEventBus } from "aws-amplify-vue";
import { accountInfoModule } from "@/store/accountInfo";
import Home from "@/views/Home.vue";

Vue.use(VueRouter);

// ログイン状態管理もルーティング系なのでここで管理する。
AmplifyEventBus.$on("authState", async (state: string) => {
  if (state === "signedOut") {
    accountInfoModule.SET_CURRENT_USER_INFO({});
    router.push({ path: "/" });
  } else if (state === "signedIn") {
    await accountInfoModule.getCurrentUserInfo();
    router.push({ path: "/members/" });
  }
});

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    meta: { requiresAuth: false }
  },
  {
    path: "/about",
    name: "about",
    title: "会社概要",
    component: () => import(/* webpackChunkName: "about" */ "@/views/About.vue"),
    meta: { requiresAuth: false }
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import(/* webpackChunkName: "contact" */ "@/views/Contact.vue"),
    meta: { requiresAuth: false }
  },
  {
    path: "/register",
    name: "register",
    component: () => import(/* webpackChunkName: "register" */ "@/views/Register.vue"),
    meta: { requiresAuth: false }
  },
  {
    path: "/login",
    name: "login",
    component: () => import(/* webpackChunkName: "login" */ "@/views/Login.vue"),
    meta: { requiresAuth: false }
  },
  {
    path: "/policy",
    name: "policy",
    component: () => import(/* webpackChunkName: "policy" */ "@/views/Policy.vue"),
    meta: { requiresAuth: false }
  },
  {
    path: "/admin",
    component: () => import(/* webpackChunkName: "admin-menu" */ "@/views/admin/menu.vue"),
    meta: { requiresAuth: true, groups: ["admin"] },
    children: [
      {
        path: "",
        name: "admin-top",
        component: () => import(/* webpackChunkName: "admin-top" */ "@/views/admin/top.vue")
      },
      {
        path: "dummpy",
        name: "admin-dummy",
        component: () => import(/* webpackChunkName: "admin-dummy" */ "@/views/admin/top.vue")
      }
    ]
  },
  {
    path: "/members",
    component: () => import(/* webpackChunkName: "members-menu" */ "@/views/members/menu.vue"),
    meta: { requiresAuth: true, groups: [] },
    children: [
      {
        path: "",
        name: "members-top",
        component: () => import(/* webpackChunkName: "members-top" */ "@/views/members/top.vue")
      },
      {
        path: "settings",
        name: "settings",
        component: () => import(/* webpackChunkName: "members-settings" */ "@/views/members/Setting.vue")
      },
      {
        path: "enquete",
        name: "enquete",
        component: () => import(/* webpackChunkName: "members-dummy" */ "@/views/members/top.vue")
      }
    ]
  },
  {
    path: "/public_notice",
    name: "public_notice",
    component: () => import(/* webpackChunkName: "public_notice" */ "@/views/PublicNotice.vue"),
    meta: { requiresAuth: false }
  },
  {
    //常に最後
    path: "*",
    name: "404",
    component: () => import(/* webpackChunkName: "404" */ "@/views/PageNotFound.vue"),
    meta: { requiresAuth: false }
  }
];

const router = new VueRouter({
  routes: routes
});

router.beforeEach((to, from, next) => {
  next();

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!accountInfoModule.isLoggedIn) {
      next({
        path: "/login",
        query: { redirect: to.fullPath }
      });
    } else {
      // ページがグループを要求していてかつユーザがグループに所属しているならOK
      if (
        to.matched.every(record => {
          if (record.meta.groups && record.meta.groups.length > 0) {
            return record.meta.groups.some((group: string) => accountInfoModule.groups.indexOf(group) >= 0);
          } else {
            return true;
          }
        })
      ) {
        next();
      } else {
        next({
          name: "404",
          query: { redirect: to.fullPath }
        });
      }
    }
  } else {
    next();
  }
});

export default router;
